module.exports = __webpack_public_path__ + "img/pc-download-module.2708b119.webp";